module.exports = __webpack_public_path__ + "img/tip1.43f76628.png";